import { render } from "./AffiliatePlatforms.vue.js?vue&type=template&id=57b4a8e9&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./AffiliatePlatforms.vue?vue&type=template&id=57b4a8e9&scoped=true"
import script from "./AffiliatePlatforms.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./AffiliatePlatforms.vue?vue&type=script&lang=js"
export * from "./AffiliatePlatforms.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./AffiliatePlatforms.vue?vue&type=script&lang=js"

import "./AffiliatePlatforms.vue.scss?vue&type=style&index=0&id=57b4a8e9&scoped=true&lang=scss!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./AffiliatePlatforms.vue?vue&type=style&index=0&id=57b4a8e9&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57b4a8e9"],['__file',"src/Web/scripts/pages/settings/AffiliatePlatforms.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "57b4a8e9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('57b4a8e9', __exports__)) {
    api.reload('57b4a8e9', __exports__)
  }
  
  module.hot.accept("./AffiliatePlatforms.vue.js?vue&type=template&id=57b4a8e9&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./AffiliatePlatforms.vue?vue&type=template&id=57b4a8e9&scoped=true", () => {
    api.rerender('57b4a8e9', render)
  })

}


export default __exports__